import type { JSX } from 'react';
import { TermDeckWorkbenchBadge } from './TermDeckWorkbenchBadge';
import { onNavClick } from '../lib/router';
import { IconChevronRight } from './icons';
import { ProductQueue } from './ProductQueue';
export function ProductPage(): JSX.Element {
  return (
    <main className="product-page">
      <p className="product-kicker">TERM-DECK</p>
      <h1>Evoluir o produto</h1>
      <p className="product-lead">
        Um espaço dedicado para seus apontamentos e para melhorar o term-deck.
      </p>
      <section className="product-launch">
        <h2>Terminal do produto</h2>
        <TermDeckWorkbenchBadge expanded />
      </section>
      {/* AL.F5 (AUD.25) — a fila do Produto com "encerrar item": resolvido fora da fila nao precisa abrir o workbench. */}
      <ProductQueue />
      <div className="product-related">
        <a href="/backlog" onClick={onNavClick('/backlog')}>
          Ver o que está planejado e entregue{' '}
          <span aria-hidden>
            <IconChevronRight />
          </span>
        </a>
        <a href="/workspace?product=1" onClick={onNavClick('/workspace?product=1')}>
          Trabalhar em frentes separadas{' '}
          <span aria-hidden>
            <IconChevronRight />
          </span>
        </a>
      </div>
    </main>
  );
}
